module.exports = __webpack_public_path__ + "static/media/thumbnail_bathy_mdmc.8f20adc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/thumbnail_bathy_mdmc.jpg
// module id = 1306
// module chunks = 0